import { useCallback, useState } from 'react';

import WpToastManager from 'Wpds/components/toast/WpToastManager';
import { handleRequestError } from 'Shared/utils/handle-request-error';
import { search } from 'Shared/api';
import { useDispatch } from 'react-redux';

export function useSearch() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const request = useCallback(
    async input => {
      setLoading(true);
      const response = await handleRequestError(search(input))
        .catch(e => {
          setError(e);
          WpToastManager.danger(e.message);
        })
        .finally(() => setLoading(false));
      dispatch({
        type: 'GET_SEARCH_RESULTS',
        payload: response.data,
      });
    },
    [dispatch]
  );
  return [request, { loading, error }];
}
